import { Divider } from "@mui/material";

import ProviderField from "./ProviderField";

export default function ProviderAdditionalContactsDisplayView({
  dataMap = {},
  typesMap,
  valueKey,
  typeKey,
  labelSuffix,
}) {
  const sortedItems = Object.entries(dataMap)
    .map(([_, obj]) => {
      if (!obj) {
        return null;
      }

      const typeOption = typesMap.get(Number(obj[typeKey]));
      if (!typeOption) {
        return null;
      }

      return {
        label: typeOption.label,
        value: obj[valueKey],
        order: typeOption.order ?? 0,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.order - b.order);

  if (sortedItems.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <Divider />
      <div className="flex flex-col gap-2 p-2">
        {sortedItems.map((item, index) => (
          <ProviderField key={index} label={`${item.label} ${labelSuffix}`} data={item.value} />
        ))}
      </div>
    </div>
  );
}
